import React, { useState } from "react";
import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import { getHourFromTimestamp } from "../../../utils";
import StyledImageContent from "./styles";

const ImageContent = (props) => {
  const { timestamp, horizontal, content } = props;
  const [hasLoaded, setHasLoaded] = useState(false);

  const onLoadCaptureHandler = () => {
    setHasLoaded(true);
  };

  const displayFallback = !hasLoaded || content === "pending";

  return (
    <StyledImageContent>
      <div className="image-content">
        <div
          className={`image-conatiner ${
            horizontal
              ? "image-conatiner--horizontal"
              : "image-conatiner--vertical"
          }`}
        >
          <div
            className={`image-loading-placeholder ${
              displayFallback ? "image-loading-placeholder--loading" : ""
            }`}
          >
            <CircularProgress />
          </div>
          <img
            src={content}
            className={`image-item ${
              displayFallback ? "image-item--loading" : ""
            }`}
            alt="chat-pic"
            onLoad={onLoadCaptureHandler}
          />
        </div>
        <div className="hour-cont">
          <Typography variant="caption" color="black">{`${getHourFromTimestamp(
            timestamp
          )}`}</Typography>
        </div>
      </div>
    </StyledImageContent>
  );
};

export default ImageContent;
